module.exports = __webpack_public_path__ + "static/media/container-storage.db757235.svg";